import ActionItemRegistry from './registry';

ActionItemRegistry.register({
    itemType: "card-substantiation-updated",
    buttons: "Done",
    values: actionItem => [
            { name: "Submitted By", value: actionItem.submittedBy },
            { name: "Option Selected", value: `Option ${actionItem.previousCardOption} => Option ${actionItem.cardOption} `  },
            { name: "Effective Date", value: moment(actionItem.effectiveDate).format("MM/DD/YYYY") },
            { name: "SA Info", value: actionItem.serviceAgreementInfo },
            { name: "SA Notes", value: actionItem.substantiationNotes }
        ]
});

ActionItemRegistry.register({
    itemType: "plan-updated",
    buttons: "Done",
    values: actionItem => [
            { name: "Plan Type", value: actionItem.plan.planType },
            { name: "Start Date", value: moment(actionItem.plan.startDate).format("MM/DD/YYYY") },
            { name: "End Date", value: moment(actionItem.plan.endDate).format("MM/DD/YYYY") },
            { name: "Annual Min", value: "$" + actionItem.plan.minimum.toFixed(2) },
            { name: "Annual Max", value: "$" + actionItem.plan.maximum.toFixed(2) }
        ]
});

ActionItemRegistry.register({
    itemType: "employer-contact",
    buttons: "Done"
});

ActionItemRegistry.register({
    itemType: "employer-broker-update",
    buttons: "Done",
    onComplete: 'employer/broker/getEmployerBroker',
    values: actionItem => [
        { name: "Broker", value: actionItem.firstName + " " + actionItem.lastName },
        { name: "Agency", value: actionItem.agency },
        { name: "Phone", value: actionItem.phone + (actionItem.phoneExtension ? "x" + actionItem.phoneExtension : "") || "n/a" },
        { name: "Fax", value: actionItem.fax || "n/a" },
        { name: "Email", value: actionItem.email || "n/a" },
    ],
    links: (actionItem) => [{
        text: "Employer Broker Update",
        href: `/employer/${actionItem.entityId}/general/broker`,
     }],
});

ActionItemRegistry.register({
  itemType:
    [
      "broker-of-record",
    ],
    buttons: [{text: "Reject", newStatus: "rejected"}]
});

ActionItemRegistry.register({
    itemType:
    [
        "member-messaging",
    ],
    buttons: "Done",
    component: "MemberMessaging",
});

ActionItemRegistry.register({
    itemType:
    [
        "funding-claims-bank-account-updated",
        "admin-fees-bank-account-updated",
        "cobra-bank-account-updated"
    ],
    buttons: "Done",
    links: (actionItem) => [{text: "View Account", href: `/employer/${actionItem.entityId}/banking`}]
});

ActionItemRegistry.register({
  itemType:
  [
      "hsa-file-upload-reminder",
  ],
  buttons: "Done",
  links: (actionItem) => [{text: "Upload Document", href: `/employer/${actionItem.entityId}/hsa/fundingbatch`}]
});


ActionItemRegistry.register({
  itemType:
    [
      "employer-termination"
    ],
  links: (actionItem) => [
    {
      text: "",
      href:
        actionItem.planIds.length > 1 ? `/employer/${actionItem.entityId}/general` :
        actionItem.planIds.length == 1 ? `/employer/${actionItem.entityId}/plans?planId=${actionItem.planIds[0]}` :
        actionItem.terminateCobra ? `/employer/${actionItem.entityId}/cobra` :
        `/employer/${actionItem.entityId}/general`
    },
  ],
  buttons: "Done",
  component: "EmployerTermination"
});



// WEBPACK FOOTER //
// ./src/action-items/types/employer-update-items.js